var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i18n',{attrs:{"path":"views.select-template.viewer"},scopedSlots:_vm._u([{key:"name",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t(("views.select-template.viewer-name." + _vm.viewerName)))+" ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }